import {useEffect, useRef} from 'react';
import {BrandsLoadingState} from '@Components/mystuff-brands/brand-kits.types';
import {getAllBrandsWithAssets} from '@Components/mystuff-brands/brands-thunk';
import {useBrandsLoadingState} from '@Hooks/brands/useBrandsLoadingState';
import {useHasContentForAllBrandKitsLoaded} from '@Hooks/brands/useHasContentForAllBrandKitsLoaded';
import {isUserLoggedIn} from '@Libraries/user.library';
import {useAppDispatch} from '@/hooks';

export const useLoadBrandKitAssets = (isEnabled: boolean): void => {
  const dispatch = useAppDispatch();
  const brandsLoadingState: BrandsLoadingState = useBrandsLoadingState();
  const hasContentForAllBrandKits = useHasContentForAllBrandKitsLoaded();
  const hasRequestedRef = useRef(false);

  useEffect(() => {
    if (!isEnabled) {
      hasRequestedRef.current = false;
      return;
    }

    if (hasRequestedRef.current || !isUserLoggedIn()) {
      return;
    }

    if (brandsLoadingState === BrandsLoadingState.LOADING || hasContentForAllBrandKits) {
      return;
    }

    hasRequestedRef.current = true;
    void dispatch(getAllBrandsWithAssets());
  }, [isEnabled, brandsLoadingState, hasContentForAllBrandKits, dispatch]);
};
